import React from 'react';

/**
 * Formats a timestamp into a human-readable relative time string.
 * e.g., "a few seconds ago", "5 minutes ago", "2 hours ago", "yesterday"
 */
function formatRelativeTime(timestamp) {
  const seconds = Math.floor((Date.now() - timestamp) / 1000);

  if (seconds < 30) return 'a few seconds ago';
  if (seconds < 90) return 'about a minute ago';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.floor(hours / 24);
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
}

/**
 * RecoveryBanner — non-modal bar shown at the top of the editor
 * when an auto-save backup is detected on startup.
 *
 * @param {object} props
 * @param {object} props.recovery - { content, fileName, timestamp }
 * @param {function} props.onRestore - called when user clicks Restore
 * @param {function} props.onDiscard - called when user clicks Discard
 */
export default function RecoveryBanner({ recovery, onRestore, onDiscard }) {
  if (!recovery) return null;

  const timeAgo = formatRelativeTime(recovery.timestamp);
  const name = recovery.fileName || 'Untitled';

  return (
    <div className="recovery-banner">
      <span className="recovery-banner-message">
        Unsaved changes to <strong>{name}</strong> recovered from {timeAgo}.
      </span>
      <div className="recovery-banner-actions">
        <button
          className="recovery-banner-button"
          onClick={onDiscard}
        >
          Discard
        </button>
        <button
          className="recovery-banner-button recovery-banner-button-primary"
          onClick={onRestore}
        >
          Restore
        </button>
      </div>
    </div>
  );
}
